/**
 * Important: We are moving away from using globally-managed modals via compose-app.
 * Please manage your modals with local state.
 *
 * Note that if you need to trigger a modal from within an iframe, you can use
 * the `useModal` hook in order to render outside of the iframe.
 */

import { createComposite } from '@opengov/component-library-classic/module/composites';
import { createModalCompositeMap } from '@opengov/component-library-classic/module/modals';

import {
  STORIES_GRANULAR_ACCESS,
  PUBLICATION_GRANULAR_ACCESS
} from '../../stories/constants';
import {
  StoryGranularAccess,
  PublicationGranularAccess
} from '../components';
import {
  selectStoryGranularAccessProps,
  selectPublicationGranularAccessProps
} from '../selectors';

const compositeFunctions = createModalCompositeMap({
  [STORIES_GRANULAR_ACCESS]: createComposite(StoryGranularAccess, selectStoryGranularAccessProps),
  [PUBLICATION_GRANULAR_ACCESS]: createComposite(PublicationGranularAccess, selectPublicationGranularAccessProps)
});

export const { component: getModalComponent, selector: getModalSelector } = compositeFunctions;
